import { useState } from "react";
import { Box, Typography } from "@mui/material";
import { styles } from "./stylesWallet";
import WalletTab from "./components/Wallet/WalletTab";
import HistoryTab from "./components/History/HistoryTab";

const Wallet = () => {
  const [activeTab, setActiveTab] = useState<"Wallet" | "History">("Wallet");

  return (
    <Box sx={styles.wallet}>
      <Box sx={styles.wrapper}>
        <Box sx={styles.header}>
          <Typography variant="h3" sx={{ fontWeight: 600 }}>
            Wallet
          </Typography>
          <Box sx={styles.tabsBox}>
            <Typography
              onClick={() => setActiveTab("Wallet")}
              sx={styles.tabItem(activeTab === "Wallet")}
            >
              Wallet
            </Typography>
            <Typography
              onClick={() => setActiveTab("History")}
              sx={styles.tabItem(activeTab === "History")}
            >
              History
            </Typography>
          </Box>
        </Box>

        <Box sx={styles.container}>
          {activeTab === "Wallet" && <WalletTab />}
          {activeTab === "History" && <HistoryTab />}
        </Box>
      </Box>
    </Box>
  );
};

export default Wallet;
